import { Dispatch, SetStateAction } from 'react';

import {
  SelectedNode,
  TreeNode,
} from 'business/data-analysis/pages/graph/components/parameter-sidebar/types';
import { parameterFamilyKeyPrefix } from 'business/data-analysis/pages/graph/types';

export const onSelectParameter = (
  setSelectedParameters: Dispatch<SetStateAction<SelectedNode[]>>,
  info: {
    node: TreeNode;
  },
) => {
  const node = info.node;
  const checkedSelectedNode = node.checked;

  if (node.key.toString().startsWith(parameterFamilyKeyPrefix)) {
    const selectedNodes = node.children!.map((child) => {
      return {
        id: parseInt(child.key),
        name: child.meta,
        unit: child.unit,
      };
    });

    setSelectedParameters((alreadySelected) => [
      ...alreadySelected.filter(
        (param) => !selectedNodes.find((p) => param.id === p.id),
      ),
      ...(!checkedSelectedNode ? selectedNodes : []),
    ]);
    return;
  }

  const selectedNode = {
    id: parseInt(node.key.toString()),
    name: node.meta,
    unit: node.unit,
  };

  setSelectedParameters((alreadySelected) =>
    [
      ...alreadySelected.filter((param) => param.id !== selectedNode.id),
      !checkedSelectedNode ? selectedNode : (undefined as any),
    ].filter(Boolean),
  );
};
